import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as TowerAPI from './towerAPI';

export const writeTower = createAsyncThunk('towerWrite/write', async ({ title, body, tags, project }, { rejectWithValue }) => {
    try {
        const response = await TowerAPI.writeTower({ title, body, tags, project });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const updateTower = createAsyncThunk('towerWrite/update', async ({ id, title, body, tags }, { rejectWithValue }) => {
    try {
        const response = await TowerAPI.updateTower({ id, title, body, tags });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    title: '',
    body: {
        size: {},
        floor: {},
        cladding: {
            roofing: {},
            siding: {},
        },
        stair: {},
        opening: {},
        hoistBeam: {},
        etc: {},
        user: {},
        weightSummary: {},
    },
    tags: [],
    tower: null, // WRITE_TOWER, UPDATE_TOWER가 성공했을 때 해당 tower를 저장. WriteActionButtonsContainer에서 이 정보를 읽어서 저장, 수정 등에 사용한다.
    towerError: null,
    originalTowerId: null, // 수정 버튼을 눌렀을 때 Tower Editor 페이지로 이동할 때 필요
    project: null,
    user: null,
}

const towerWriteSlice = createSlice({
    name: 'towerWrite',
    initialState,
    reducers: {
        initialize: state => initialState,
        changeField: (state, { payload: { key, value } }) => {
            state[key] = value;
        },
        changeBody: (state, { payload: { key, value } }) => {
            state.body[key] = value;
        },
        summaryWeight: (state, { payload: { key, value } }) => {
            state.body.weightSummary[key] = value;
        },
        setOriginalTower: (state, { payload: tower }) => {
            state.title = tower.title;
            state.body = tower.body;
            state.tags = tower.tags;
            state.project = tower.project;
            state.user = tower.user;
            state.originalTowerId = tower._id;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(writeTower.fulfilled, (state, { payload }) => {
                state.tower = payload;
                state.towerError = null;
            })
            .addCase(writeTower.rejected, (state, { payload }) => {
                state.tower = null;
                state.towerError = payload;
            })
            .addCase(updateTower.fulfilled, (state, { payload }) => {
                state.tower = payload;
                state.towerError = null;
            })
            .addCase(updateTower.rejected, (state, { payload }) => {
                state.tower = null;
                state.towerError = payload;
            })
    }
});

// 액션과 리듀서 내보내기
export const { initialize, changeField, changeBody,  summaryWeight, setOriginalTower } = towerWriteSlice.actions;
export default towerWriteSlice.reducer;